<template>
  <div class="container">
    <h4 class="blue-text font-weight-bold">プロフィール変更完了</h4>

    <b-modal
      id="user-profile-update-success-modal"
      class="border-radius-2"
      size="md"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      centered
    >
      <h5
        class="grey-text dark-blue-text-hover float-right pl-1 pr-1"
        v-on:click="$router.push({
                    name: 'userRoute-dashboard',
                  })"
      >
        <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'times' }" />
      </h5>
      <div class="container text-center">
        <img class="mt-4" src="/img/icons/ico-info.svg" alt="ico-info" />
        <h5 class="mt-4 mb-0 dark-blue-text font-weight-bold">
          プロフィールの変更が完了しました。
        </h5>
        <div class="row mb-3 mt-5">
          <div class="col-12">
            <button
              class="btn btn-ds dark-blue white-text pt-2 pb-2"
              type="button"
              v-waves.light
              v-on:click="$router.push({
                    name: 'userRoute-dashboard',
                  })"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// Import Vuex/Store
import { mapGetters } from 'vuex';

// Import Services
import {
  cus_userService_RegistUserProfile
} from '../../services/customer/users';

//import common
import {
} from '../../common/Utility';

export default {
  metaInfo() {
    return {
      title: 'Digital Staging - Profile | User Regist',
    };
  },

  components: {
  },

  data() {
    return {
      token: null,
    };
  },

  computed: {
    ...mapGetters(['currentUser', 'isLoggedIn']),
  },

  async mounted() {
    await this.setToken();
    this.registUser();
  },

  methods: {
    setToken() {
      this.token = this.$route.query['token'];
      console.log(this.token);
    },
    async registUser(e) {
      this.$store.state.modalLoaderMessage = '保存中';
      this.$bvModal.show('modal-loader');
      let accessToken = localStorage.getItem('_accessToken');

      let success = false;

      //Update Profile
      await cus_userService_RegistUserProfile({
        token: this.token,
        accessToken: accessToken,
      })
        .then(() => {
          success = true;
        })
        .catch((error) => {
          console.log(error);
          success = false;
          this.formMessage =
            'プロフィールの更新中にエラーが起こりました。再度お試しください。';
        });

      setTimeout(() => {
        this.$bvModal.hide('modal-loader');
      }, 500);
      if (success) {
        setTimeout(() => {
          this.$bvModal.show('user-profile-update-success-modal');
        }, 500);
      }
    },
  },
};
</script>

<style scoped>
/* Init Style */
/* Custom style */
</style>
